import "air-datepicker/dist/js/datepicker.min.js";
import "./frappe/form/controls/datepicker_i18n.js";
import "./frappe/ui/capture.js";
import "./frappe/form/controls/control.js";
